import React from 'react'
import { render } from 'react-dom'
import App from './components/index.jsx'
import './scss/index.scss'
import { Provider } from 'react-redux';
import outdatedBrowserRework from './outdatebrowser.js';
import configureStore from './redux/store/configureStore';
import {
    Route,
    browserHistory,
    HashRouter,
} from 'react-router-dom';

import './icons/index';

const store = configureStore();
outdatedBrowserRework();

render(
    <HashRouter history={browserHistory}>
        <Provider store={store}>
            <Route path="/" component={App} />
        </Provider>
    </HashRouter>,
    document.getElementById('wallet-front')
)
